import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { ComputationNodeType, RuleComputation } from 'src/app/_shared/services/advanced-rule/advanced-rule.service';

export interface SharedAdvancedRuleComputationDetailDialogData {
    label: string;

    computations: RuleComputation[];
}

@Component({
    selector: 'app-shared-advanced-rule-computation-detail-dialog',
    templateUrl: './shared-advanced-rule-computation-detail-dialog.component.html',
    styleUrls: ['./shared-advanced-rule-computation-detail-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAdvancedRuleComputationDetailDialogComponent {

    nodeType = ComputationNodeType;

    paramsNode: RuleComputation = null;

    constructor(private readonly dialogRef: KalDialogRef<SharedAdvancedRuleComputationDetailDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public readonly data: SharedAdvancedRuleComputationDetailDialogData) {
    }

    showParams(node: RuleComputation): void {
        this.paramsNode = node;
    }

    close(): void {
        this.dialogRef.close();
    }

}
